export default __webpack_public_path__ + "static/media/cv.c4df14ee.svg";